import React from 'react';

/**
 * Sticky bottom action bar. Renders anchored to the bottom of the
 * nearest scroll container (position:sticky). Great for long forms
 * and editors so Save/Publish never scrolls out of view.
 *
 * Usage:
 *   <StickyActionBar visible={isDirty}>
 *     <Button variant="outline" onClick={discard}>Discard</Button>
 *     <Button onClick={save}>Save</Button>
 *   </StickyActionBar>
 */
export default function StickyActionBar({
  visible = true,
  children,
  message,
  className = '',
  align = 'right',
  testId = 'sticky-action-bar',
}) {
  if (!visible) return null;
  return (
    <div
      data-testid={testId}
      className={`sticky bottom-0 left-0 right-0 z-30 mt-6 border-t bg-card/95 backdrop-blur px-4 py-3 shadow-[0_-4px_16px_-8px_rgba(0,0,0,0.15)] ${className}`}
    >
      <div
        className={`flex items-center gap-3 ${
          align === 'right' ? 'justify-end' : align === 'center' ? 'justify-center' : 'justify-between'
        }`}
      >
        {message && (
          <div className="text-xs text-muted-foreground mr-auto">{message}</div>
        )}
        <div className="flex items-center gap-2">{children}</div>
      </div>
    </div>
  );
}
